// extracted by mini-css-extract-plugin
module.exports = {"addTenantRow":"CreateTenant_addTenantRow__2UDFw","tenantError":"CreateTenant_tenantError__388zH","createTenantRow":"CreateTenant_createTenantRow__332dX"};